import React, { useContext, useState } from 'react';
import { FilterContext } from '@op/pages/Summary/context';
import TopicLevelOneTable from './TopicLevelOneTable';
import TopicLevelTwoTable from './TopicLevelTwoTable';
import { LanguageType } from '@op/types/common';
import { clickTopicToFeedsWithTab } from '@op/utils/url';
import { useHistory } from 'umi';
import TopicTableFilter from '../TopicPerformanceFilter';
import { useStateRef } from '@op/hooks/common';
import { sortable } from 'tea-component/lib/table/addons';

export default function TopicPerformanceTable({
  language,
  setLanguage,
  isTopicSentiment,
}: {
  language: LanguageType;
  setLanguage: (language: LanguageType) => void;
  isTopicSentiment: string;
}) {
  const { filter, topicLevel, transTopic, topicTree, gameInfo, topicList } =
    useContext(FilterContext);

  const [topNRef, topN, setTopN] = useStateRef(10);
  const [selectTopNRef, selectTopN, setSelectTopN] = useStateRef(true);

  const history = useHistory();
  const goToFeeds = (topic: string, topicLevel: 'L1' | 'L2' = 'L2') => {
    let topics: any = [topic];
    if (topicLevel === 'L1') {
      topics = topicTree[topic];
    }
    clickTopicToFeedsWithTab({
      filter: { ...filter, topic: topics },
      gameInfo,
      history,
    });
  };

  function sortData(
    list: Array<any>,
    sort: { by: string; order: 'desc' | 'asc' },
  ) {
    const isDesc = sort.order === 'desc';
    if (sort.by === 'avg_sentiment') {
      list.sort((a, b) => {
        // 处理 undefined/null（视为 0）
        const valA = a.avg_sentiment || 0;
        const valB = b.avg_sentiment || 0;

        // 情况1：a 是 0，b 不是 0 → a 排到最后
        if (valA === 0 && valB !== 0) return 1;
        // 情况2：b 是 0，a 不是 0 → b 排到最后
        if (valB === 0 && valA !== 0) return -1;
        // 情况3：两者都是 0 → 保持原顺序
        if (valA === 0 && valB === 0) return 0;

        // 正常比较非零值
        return (valA - valB) * (isDesc ? -1 : 1);
      }); 
    } else {
      list.sort(sortable.comparer([sort]));
    }

    return list;
  }

  return (
    <>
      <TopicTableFilter
        topN={topN}
        setTopN={setTopN}
        selectTopN={selectTopN}
        setSelectTopN={setSelectTopN}
        setLanguageType={setLanguage}
      ></TopicTableFilter>
      {topicLevel === 'L1' ? (
        <TopicLevelOneTable
          filter={filter}
          transTopic={transTopic}
          language={language}
          gameInfo={gameInfo}
          goToFeeds={goToFeeds}
          topicList={topicList}
          topN={topN}
          selectTopN={selectTopN}
          isTopicSentiment={isTopicSentiment}
          sortData={sortData}
        ></TopicLevelOneTable>
      ) : (
        <TopicLevelTwoTable
          filter={filter}
          transTopic={transTopic}
          language={language}
          goToFeeds={goToFeeds}
          topicList={topicList}
          topN={topN}
          sortData={sortData}
          topNRef={topNRef}
          selectTopN={selectTopN}
          selectTopNRef={selectTopNRef}
          gameInfo={gameInfo}
          isTopicSentiment={isTopicSentiment}
        ></TopicLevelTwoTable>
      )}
    </>
  );
}
